import React from "react";
import { PageHeaderProps } from "../../../types";
import "./PageHeader.css";

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, action, className = "", style }) => {
  return (
    <div className={`page-header-container ${className}`} style={style}>
      <div className="page-header-text">
        {/* {title && <h2 className="page-header-title">{title}</h2>} */}
        {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
      </div>
      {action && <div className="page-header-action">{action}</div>}
    </div>
  );
};

export default PageHeader;
